var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconInfoWarningComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-Info-warning ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    fill: useCurrentColor ? 'currentColor' : '#E19F0B'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99997 5.34039C8.52167 5.34039 8.94458 4.91747 8.94458 4.39578C8.94458 3.87409 8.52167 3.45117 7.99997 3.45117C7.47828 3.45117 7.05537 3.87409 7.05537 4.39578C7.05537 4.91747 7.47828 5.34039 7.99997 5.34039ZM8.5 6.24587V6.24213H6.83C6.64775 6.24213 6.5 6.38988 6.5 6.57213V7.24213C6.5 7.42439 6.64775 7.57213 6.83 7.57213H7.61792V11.2421H6.94792C6.76567 11.2421 6.61792 11.3899 6.61792 11.5721L6.61792 12.2421C6.61792 12.4244 6.76567 12.5721 6.94792 12.5721H9.28792C9.47017 12.5721 9.61792 12.4244 9.61792 12.2421V11.5721C9.61792 11.3899 9.47017 11.2421 9.28792 11.2421H8.94792V6.57587C8.94792 6.39362 8.80017 6.24587 8.61792 6.24587H8.5Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconInfoWarning = /*#__PURE__*/React.forwardRef(IconInfoWarningComponent);
export default IconInfoWarning;